/** Enum of Berries (NAME - ID) */
export const BERRIES = {
  CHERI: 1,
  CHESTO: 2,
  PECHA: 3,
  RAWST: 4,
  ASPEAR: 5,
  LEPPA: 6,
  ORAN: 7,
  PERSIM: 8,
  LUM: 9,
  SITRUS: 10,
  FIGY: 11,
  WIKI: 12,
  MAGO: 13,
  AGUAV: 14,
  IAPAPA: 15,
  RAZZ: 16,
  BLUK: 17,
  NANAB: 18,
  WEPEAR: 19,
  PINAP: 20,
  POMEG: 21,
  KELPSY: 22,
  QUALOT: 23,
  HONDEW: 24,
  GREPA: 25,
  TAMATO: 26,
  CORNN: 27,
  MAGOST: 28,
  RABUTA: 29,
  NOMEL: 30,
  SPELON: 31,
  PAMTRE: 32,
  WATMEL: 33,
  DURIN: 34,
  BELUE: 35,
  OCCA: 36,
  PASSHO: 37,
  WACAN: 38,
  RINDO: 39,
  YACHE: 40,
  CHOPLE: 41,
  KEBIA: 42,
  SHUCA: 43,
  COBA: 44,
  PAYAPA: 45,
  TANGA: 46,
  CHARTI: 47,
  KASIB: 48,
  HABAN: 49,
  COLBUR: 50,
  BABIRI: 51,
  CHILAN: 52,
  LIECHI: 53,
  GANLON: 54,
  SALAC: 55,
  PETAYA: 56,
  APICOT: 57,
  LANSAT: 58,
  STARF: 59,
  ENIGMA: 60,
  MICLE: 61,
  CUSTAP: 62,
  JABOCA: 63,
  ROWAP: 64,
  KEE: 65,
  MARANGA: 66,
  HOPO: 67,
  ROSELI: 68,
} as const;

/** Enum of Berry Firmnesses (NAME - ID) */
export const BERRY_FIRMNESSES = {
  VERY_SOFT: 1,
  SOFT: 2,
  HARD: 3,
  VERY_HARD: 4,
  SUPER_HARD: 5,
} as const;

export const BERRY_FLAVORS = {
  SPICY: 1,
  DRY: 2,
  SWEET: 3,
  BITTER: 4,
  SOUR: 5,
} as const;
